<template>
  <div class="ms-levels">
    <div class="ms-level-toolbar">
      <span>所选规则：<strong>{{ config.snapshot.root.ruleName }}</strong></span>
      <el-button v-if="!readonly" size="small" icon="el-icon-plus" :disabled="config.levels.length >= 8" @click="addLevel">增加等级</el-button>
    </div>
    <el-tabs v-model="active">
      <el-tab-pane v-for="(level, index) in config.levels" :key="level.id" :name="level.id" :label="level.name || '未命名等级'">
        <div class="ms-level-name" v-if="!readonly">
          <span>等级 {{ index + 1 }}</span>
          <el-input v-model="level.name" size="small" maxlength="30" label="等级名称" />
          <el-tooltip v-if="index === config.levels.length - 1" :content="config.levels.length === 1 ? '至少保留一级' : '删除最高等级'" placement="top">
            <span><el-button size="small" icon="el-icon-delete" :disabled="config.levels.length === 1" aria-label="删除最高等级" @click="deleteLevel(level.id)" /></span>
          </el-tooltip>
        </div>
        <div class="ms-tree-scroll">
          <SnapshotTree :node="config.snapshot.root" :values="level.values" :readonly="readonly" @change="changeValue(level, $event)" />
        </div>
        <div class="ms-actions">
          <strong>措施</strong>
          <ul v-if="readonly" class="ms-actions-readonly"><li v-for="action in level.actions" :key="action.type">{{ actionText(action) }}</li></ul>
          <el-checkbox-group v-else :value="level.actions.map(action => action.type)" @input="changeActions(level, $event)">
            <el-checkbox v-for="action in actions" :key="action[0]" :label="action[0]">{{ action[1] }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <template v-if="!readonly">
          <div v-for="action in level.actions.filter(item => item.type === 'ENABLE_CFD')" :key="action.type" class="ms-cfd">
            <label>CFD市价滑点下限 <el-input v-model="action.slippageLow" size="small" label="CFD市价滑点下限" /></label>
            <label>CFD市价滑点上限 <el-input v-model="action.slippageHigh" size="small" label="CFD市价滑点上限" /></label>
            <el-tooltip content="0至0.1，最多6位小数；上限不能小于下限。" placement="top"><i class="el-icon-question" tabindex="0" /></el-tooltip>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SnapshotTree from './SnapshotTree.vue'
import { ACTIONS, actionText, nextLevel } from './model'

export default {
  name: 'StrategyLevels',
  components: { SnapshotTree },
  props: { config: { type: Object, required: true }, readonly: { type: Boolean, default: false } },
  data() { return { active: this.config.levels[0].id, actions: ACTIONS } },
  methods: {
    actionText,
    changeValue(level, change) { this.$set(level.values, change.id, change.cell) },
    changeActions(level, types) {
      level.actions = types.map(type => level.actions.find(action => action.type === type) || (type === 'ENABLE_CFD' ? { type, slippageLow: '', slippageHigh: '' } : { type }))
    },
    addLevel() {
      if (this.readonly || this.config.levels.length >= 8) return
      const level = nextLevel(this.config.levels)
      this.config.levels.push(level)
      this.active = level.id
    },
    async deleteLevel(id) {
      const levels = this.config.levels
      if (this.readonly || levels.length <= 1 || levels[levels.length - 1].id !== id) return
      try {
        await this.$confirm('删除最高等级及其参数、措施？', '删除等级', { type: 'warning', confirmButtonText: '删除', cancelButtonText: '取消' })
        levels.pop()
        this.active = levels[levels.length - 1].id
      } catch (_) { /* 用户取消 */ }
    },
  },
}
</script>

<style lang="less" scoped>
.ms-level-toolbar { display: flex; justify-content: space-between; align-items: center; gap: 16px; padding: 18px 0; }
.ms-level-name { display: flex; align-items: center; gap: 12px; margin: 8px 0; }
.ms-level-name .el-input { width: 200px; }
.ms-tree-scroll { overflow: auto; max-height: 58vh; padding: 12px 0; margin: 8px 0 20px; }
.ms-actions { border-top: 1px solid #ebeef5; display: flex; align-items: flex-start; gap: 24px; padding: 18px 0 6px; }
.ms-actions > strong { flex: 0 0 36px; line-height: 28px; }
.ms-actions .el-checkbox { line-height: 28px; }
.ms-actions-readonly { margin: 0; padding-left: 18px; line-height: 28px; }
.ms-cfd { display: flex; align-items: center; flex-wrap: wrap; gap: 18px; padding: 12px 0; }
.ms-cfd label { display: flex; align-items: center; gap: 10px; }
.ms-cfd .el-input { width: 130px; }
</style>
